const versions = new Map();
const listeners = new Set();
export const subscribeToColumnMapChanges = listener => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
export const getColumnMapVersion = propertyUtilityId => {
  var _versions$get;
  return (_versions$get = versions.get(propertyUtilityId)) !== null && _versions$get !== void 0 ? _versions$get : 0;
};
export const noteColumnMapChange = propertyUtilityId => {
  versions.set(propertyUtilityId, getColumnMapVersion(propertyUtilityId) + 1);
  listeners.forEach(listener => listener());
};